export const navigationPaths = {
    'about': '#/about',
    'contact': '#/contact',
    'default': '#/default',
    'pricing': '#/pricing'
}